import Client from './Client'
import TokenService from './TokenService'

const AuthService = {
    getDefault(){
        return {
            full_name : undefined,
            mobile : undefined,
            password : undefined,
            confirm_password : undefined
        }
    },
    /**
     * Login the user and store the access token to TokenService.
     *
     * @returns access_token
     * @throws AuthenticationError
     **/
    async createSession(mobile, password) {
        return await Client.post('/admin/auth/create-session', {
            mobile,
            password
        });
    },

    logout() {
        TokenService.removeToken();
    }
}

export default AuthService